export const DEFAULT_LOCALE = 'en';
export const OPEN_PAGE = 'OPEN_PAGE';
export const STOP_LOADER = 'STOP_LOADER';
export const START_LOADER = 'START_LOADER';
export const APOLLO_QUERY_RESULT = 'APOLLO_QUERY_RESULT';
export const APOLLO_MUTATION_RESULT = 'APOLLO_MUTATION_RESULT';

export const ADD_GLOBAL_ERROR = 'ADD_GLOBAL_ERROR';
export const DEFAULT_GLOBAL_ERROR_MESSAGE =
  'Something went wrong! Please refresh and try again or give us a call 1-855-695-2255';
export const REMOVE_GLOBAL_ERROR = 'REMOVE_GLOBAL_ERROR';
export const SUBMISSION_ERROR_MESSAGE =
  'Hmmm. Please review any flagged areas below before we move on.';
export const EXISTING_EMAIL_ERROR_MESSAGE = 'has already been taken';

export const PHONE_NUMBER = '1-855-695-2255';
export const PRETTY_PHONE_NUMBER = '(855) 695-2255';

export const UPDATE_ACTIVE_IDS = 'UPDATE_ACTIVE_IDS';
export const UPDATE_LIFE_SUPPORT_PREFERENCES = 'UPDATE_LIFE_SUPPORT_PREFERENCES';

export enum PaymentMode {
  MONTHLY = 'monthly',
  YEARLY = 'annual',
}
export const PAYMENT_LABEL_MONTHLY_FORMAT = 'mo';
export const PAYMENT_LABEL_YEARLY_FORMAT = 'yr';
export const PAYMENT_TYPE_MONTHLY = 'monthlyPremium';
export const PAYMENT_TYPE_YEARLY = 'annualPremium';

export const PRODUCT_TYPE_WHOLE = 'whole';
export const PRODUCT_TYPE_TERM = 'term';
export const PRODUCT_TYPE_UNIVERSAL = 'universal';

export const SELECT_ANNUAL_PAYMENT_MODE = 'SELECT_ANNUAL_PAYMENT_MODE';
export const SELECT_MONTHLY_PAYMENT_MODE = 'SELECT_MONTHLY_PAYMENT_MODE';

export const UPDATE_PERMANENT_POLICY_ESTIMATE = 'UPDATE_PERMANENT_POLICY_ESTIMATE';

export const SET_HAS_EMAIL = 'SET_HAS_EMAIL';

// Based on smart_term fallback: https://github.com/policygenius/policygenius/blob/main/app/models/life/policy_preferences.rb#L37
export const DEFAULT_TERM = '20';
// Based on smart_covarage_amount fallback:  https://github.com/policygenius/policygenius/blob/main/app/models/life/policy_preferences.rb#L41
export const DEFAULT_COVERAGE = 500000;

export const CARRIER_SLUGS = {
  AIG: 'aig',
  BANNER: 'banner-life',
  BRIGHTHOUSE: 'brighthouse',
  FORESTERS: 'foresters',
  LINCOLN: 'lincoln-national-life',
  MUTUAL_OF_OMAHA: 'mutual-of-omaha',
  PAC_LIFE: 'pacific-life',
  POLICYGENIUS: 'policygenius', // Estimated whole life
  PRINCIPAL: 'principal-financial-group',
  PROTECTIVE: 'protective',
  PRUDENTIAL: 'prudential',
  SBLI: 'sbli',
  SYMETRA: 'symetra',
  TRANSAMERICA: 'transamerica',
} as const;

export const STATES = [
  { value: 1, displayText: 'Alabama' },
  { value: 2, displayText: 'Alaska' },
  { value: 3, displayText: 'Arizona' },
  { value: 4, displayText: 'Arkansas' },
  { value: 5, displayText: 'California' },
  { value: 6, displayText: 'Colorado' },
  { value: 7, displayText: 'Connecticut' },
  { value: 8, displayText: 'Delaware' },
  { value: 9, displayText: 'District Of Columbia' },
  { value: 10, displayText: 'Florida' },
  { value: 11, displayText: 'Georgia' },
  { value: 12, displayText: 'Hawaii' },
  { value: 13, displayText: 'Idaho' },
  { value: 14, displayText: 'Illinois' },
  { value: 15, displayText: 'Indiana' },
  { value: 16, displayText: 'Iowa' },
  { value: 17, displayText: 'Kansas' },
  { value: 18, displayText: 'Kentucky' },
  { value: 19, displayText: 'Louisiana' },
  { value: 20, displayText: 'Maine' },
  { value: 21, displayText: 'Maryland' },
  { value: 22, displayText: 'Massachusetts' },
  { value: 23, displayText: 'Michigan' },
  { value: 24, displayText: 'Minnesota' },
  { value: 25, displayText: 'Mississippi' },
  { value: 26, displayText: 'Missouri' },
  { value: 27, displayText: 'Montana' },
  { value: 28, displayText: 'Nebraska' },
  { value: 29, displayText: 'Nevada' },
  { value: 30, displayText: 'New Hampshire' },
  { value: 31, displayText: 'New Jersey' },
  { value: 32, displayText: 'New Mexico' },
  { value: 33, displayText: 'New York' },
  { value: 34, displayText: 'North Carolina' },
  { value: 35, displayText: 'North Dakota' },
  { value: 36, displayText: 'Ohio' },
  { value: 37, displayText: 'Oklahoma' },
  { value: 38, displayText: 'Oregon' },
  { value: 39, displayText: 'Pennsylvania' },
  { value: 40, displayText: 'Rhode Island' },
  { value: 41, displayText: 'South Carolina' },
  { value: 42, displayText: 'South Dakota' },
  { value: 43, displayText: 'Tennessee' },
  { value: 44, displayText: 'Texas' },
  { value: 45, displayText: 'Utah' },
  { value: 46, displayText: 'Vermont' },
  { value: 47, displayText: 'Virginia' },
  { value: 48, displayText: 'Washington' },
  { value: 49, displayText: 'West Virginia' },
  { value: 50, displayText: 'Wisconsin' },
  { value: 51, displayText: 'Wyoming' },
];

export const DPID_STATES = [
  { value: 'AL', displayText: 'Alabama' },
  { value: 'AK', displayText: 'Alaska' },
  { value: 'AZ', displayText: 'Arizona' },
  { value: 'AR', displayText: 'Arkansas' },
  { value: 'CA', displayText: 'California' },
  { value: 'CO', displayText: 'Colorado' },
  { value: 'CT', displayText: 'Connecticut' },
  { value: 'DE', displayText: 'Delaware' },
  { value: 'DC', displayText: 'District Of Columbia' },
  { value: 'FL', displayText: 'Florida' },
  { value: 'GA', displayText: 'Georgia' },
  { value: 'HI', displayText: 'Hawaii' },
  { value: 'ID', displayText: 'Idaho' },
  { value: 'IL', displayText: 'Illinois' },
  { value: 'IN', displayText: 'Indiana' },
  { value: 'IA', displayText: 'Iowa' },
  { value: 'KS', displayText: 'Kansas' },
  { value: 'KY', displayText: 'Kentucky' },
  { value: 'LA', displayText: 'Louisiana' },
  { value: 'ME', displayText: 'Maine' },
  { value: 'MD', displayText: 'Maryland' },
  { value: 'MA', displayText: 'Massachusetts' },
  { value: 'MI', displayText: 'Michigan' },
  { value: 'MN', displayText: 'Minnesota' },
  { value: 'MS', displayText: 'Mississippi' },
  { value: 'MO', displayText: 'Missouri' },
  { value: 'MT', displayText: 'Montana' },
  { value: 'NE', displayText: 'Nebraska' },
  { value: 'NV', displayText: 'Nevada' },
  { value: 'NH', displayText: 'New Hampshire' },
  { value: 'NJ', displayText: 'New Jersey' },
  { value: 'NM', displayText: 'New Mexico' },
  { value: 'NY', displayText: 'New York' },
  { value: 'NC', displayText: 'North Carolina' },
  { value: 'ND', displayText: 'North Dakota' },
  { value: 'OH', displayText: 'Ohio' },
  { value: 'OK', displayText: 'Oklahoma' },
  { value: 'OR', displayText: 'Oregon' },
  { value: 'PA', displayText: 'Pennsylvania' },
  { value: 'RI', displayText: 'Rhode Island' },
  { value: 'SC', displayText: 'South Carolina' },
  { value: 'SD', displayText: 'South Dakota' },
  { value: 'TN', displayText: 'Tennessee' },
  { value: 'TX', displayText: 'Texas' },
  { value: 'UT', displayText: 'Utah' },
  { value: 'VT', displayText: 'Vermont' },
  { value: 'VA', displayText: 'Virginia' },
  { value: 'WA', displayText: 'Washington' },
  { value: 'WV', displayText: 'West Virginia' },
  { value: 'WI', displayText: 'Wisconsin' },
  { value: 'WY', displayText: 'Wyoming' },
];

// Common DPID URNs
export const DOB_URN = 'urn:pg:data-point:insured-date-of-birth';
export const HEIGHT_FEET_URN = 'urn:pg:data-point:insured-height-feet';
export const HEIGHT_INCHES_URN = 'urn:pg:data-point:insured-height-inches';
